import { SvgIcon } from '@mui/material';

export default function AppBannerLogo(props: any) {
  return (
    <SvgIcon width="14" height="17" viewBox="0 0 14 17" fill="none" {...props} style={{ ...props.style }}>
      <g clipPath="url(#clip0_4436_45637)">
        <path
          id="Trazado 6612"
          d="M10.8584 10.8829C11.7103 10.4039 12.4111 9.72338 12.8898 8.9103C13.3685 8.09722 13.6079 7.18056 13.5839 6.25332C13.5839 3.27924 11.3195 0.845703 7.25379 0.845703H0V3.59217C0.000243741 4.32607 0.31305 5.02986 0.869657 5.54881C1.42626 6.06776 2.18111 6.35941 2.96828 6.35963C2.18111 6.35986 1.42626 6.6515 0.869657 7.17046C0.31305 7.68941 0.000243741 8.39319 0 9.1271V16.5696H4.02023V11.8543H7.18437L9.56414 16.5696H14L10.8584 10.8829ZM9.7577 6.37249C8.98585 6.52949 8.27843 6.88943 7.7192 7.40968C7.15998 7.92993 6.77237 8.58871 6.6023 9.308V9.31786L6.59356 9.28999C6.42358 8.57434 6.03827 7.91872 5.48281 7.4C4.92735 6.88128 4.22477 6.52098 3.45747 6.36135H3.44828L3.45333 6.35792C4.22296 6.19973 4.92813 5.83991 5.4859 5.32079C6.04366 4.80167 6.43082 4.14484 6.60184 3.42756L6.60552 3.43913C6.77524 4.15398 7.15987 4.80896 7.71438 5.32739C8.26888 5.84582 8.97031 6.20626 9.73655 6.36649L9.76092 6.37121L9.7577 6.37249Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4436_45637">
          <rect width="14" height="16.1538" fill="white" transform="translate(0 0.845703)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
